import { Label } from 'office-ui-fabric-react/lib/Label';
import { css, FlattenSimpleInterpolation } from 'styled-components';
import { IPlaceholderProps } from '../../../models/IPlaceholderProps';
import { IResolutionProps } from '../../../models/IResolutionProps';
import { ICustomTdProps } from './MetadataPanel';
import { ComboBox } from 'office-ui-fabric-react';

interface IGenerationFormProps {
  isGenerationRestricted: boolean;
}

export const Placeholder = styled.div.attrs({ 'aria-hidden': true })`
  background-color: #e5e5e5;
  color: #e5e5e5;
  text-align: center;
  animation: placeholderBlinks 1s infinite;
`;

export const PlaceholderSidePanelContainer = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const GenerationForm = styled.fieldset<IGenerationFormProps>`
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  opacity: ${({ isGenerationRestricted }): number => (isGenerationRestricted ? 0.55 : 1)};
`;

export const RestrictedFormWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const RestrictedOverlay = styled.div`
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 92%;
  z-index: 10;
`;

export const TokensTable = styled.table`
  width: 100%;
  &&& {
    table,
    th,
    td {
      border-collapse: collapse;
      width: 50%;
    }
    th,
    td,
    tr {
      padding-top: 5px;
    }
  }
`;

export const ControlsTable = styled.table<IResolutionProps>`
  width: calc(100% - 10px);
  &&& {
    table,
    th,
    td:nth-child(1) {
      border-collapse: collapse;
      width: 50%;
      ${({ windowWidth }): number | FlattenSimpleInterpolation =>
        windowWidth < 700 &&
        css`
          display: inline;
        `}
    }
    th,
    td,
    tr {
      padding-top: 5px;
    }
  }
`;

export const NewControlsTable = styled.div`
  display: flex;
  width: calc(100% - 10px);
  flex-direction: column;
`;

export const ControlsTableRow = styled.div`
  display: flex;
  padding-top: 5px;
  flex-direction: row;
`;

export const ControlsTableData = styled.div`
  display: flex;
  width: 50%;
  flex-direction: row;
`;

export const TemplatesPlaceHolder = styled(Placeholder)<IPlaceholderProps>`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}%;
  margin-bottom: 10px;
`;

export const BreakFlexDiv = styled.div`
  flex-basis: 100%;
  height: 0;
`;

export const FormErrorValidationMessage = styled(Label)`
  font-size: 11px;
  color: #e00000; //red
  font-weight: 600;
  margin: 0;
`;

export const SidePanelErrorContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column !important;
  margin-top: 150px;
`;

export const ErrorLoadingTokens = styled.img`
  width: 120px;
  height: 100px;
  margin-bottom: 10px;
`;

export const OptionalCommentsContainer = styled.div`
  margin-top: 35px;
`;

export const OptionalCommentsLabel = styled.label`
  color: #646464;
`;

export const TextAreaField = styled.textarea`
  width: 100%;
`;

export const CustomDropDownWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const CustomDropDown = styled(ComboBox)<IResolutionProps>`
  width: 100%;
`;

export const CustomTd = styled.td<ICustomTdProps>`
  &&& {
    ${({ controlType }): string | FlattenSimpleInterpolation =>
      controlType === 'DropDown' &&
      css`
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      `}

    ${({ controlType, windowWidth }): string | number | FlattenSimpleInterpolation =>
      controlType != 'DropDown' &&
      windowWidth >= 700 &&
      css`
        width: 50%;
      `}

        ${({ controlType, windowWidth }): string | number | FlattenSimpleInterpolation =>
      controlType != 'DropDown' &&
      windowWidth < 700 &&
      css`
        display: inline;
      `}
  }
`;
